import _ from 'lodash';
import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { EVALUATION_FORM_FIELDS } from '@/views/ListReport/Report/Owas/enums';
import { CustomFormItem } from '../../styles';
import { CustomTextArea } from '../styles';

interface ManualToolsProps {
	formName: string[];
}

const { useFormInstance } = Form;

export function ManualTools({ formName }: Readonly<ManualToolsProps>): JSX.Element {
	const form = useFormInstance();
	const title = I18n.get('Manual tools');
	const fieldName = [...formName, EVALUATION_FORM_FIELDS.MANUAL_TOOLS];

	const debounceSetValue = _.debounce((value: string) => {
		form.setFieldValue(fieldName, value);
	}, 1000);

	function handleChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
		const value = e.currentTarget?.value;
		debounceSetValue(value);
	}

	return (
		<Row>
			<Col span={24}>
				<Form.Item hidden name={fieldName} />
				<CustomFormItem
					label={title}
					labelCol={{ span: 24 }}
					name={[...formName, 'manual_tools_input']}
					rules={[{ required: true, message: I18n.get('Enter the manual tools') }]}
				>
					<CustomTextArea placeholder={title} onChange={handleChange} rows={4} maxLength={200} showCount />
				</CustomFormItem>
			</Col>
		</Row>
	);
}
